import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CastleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"castle"}/>
}
